// @core/api/endpoints/team/list_team_ownership_transfers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamOwnershipTransfersResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List ownership transfers
 * Returns the history of ownership transfer requests for a team including pending, completed, and cancelled transfers.
 */
export async function ListTeamOwnershipTransfers(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamOwnershipTransfersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/ownership-transfers`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamOwnershipTransfersResponse>(requestPath, { ...requestOptions, params });
}
